import { Center, Loader } from "@mantine/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");

    if (error) {
      const description = params.get("error_description");
      console.warn("[AuthCallback] Auth0 callback error:", { error, description });
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <Center h="100vh">
      <Loader />
    </Center>
  );
};
